import { Selection } from "../../contracts";

export const sortSelectionsByOdd = (s1: Selection, s2: Selection) => {
    return s1.trueOdds - s2.trueOdds;
}